import React from 'react'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import { addRatingToAcceptJobWithoutCode } from '../api'

export default React.createClass({
  getInitialState: function() {
    return {
        ratingComment: '',
        star1: '/common/latest/images/consumer/rating-stars/0-gray-star.png',
        star2: '/common/latest/images/consumer/rating-stars/0-gray-star.png',
        star3: '/common/latest/images/consumer/rating-stars/0-gray-star.png',
        star4: '/common/latest/images/consumer/rating-stars/0-gray-star.png',
        star5: '/common/latest/images/consumer/rating-stars/0-gray-star.png',
        rating: ''
    }
  },
  sendUpdateToServer: function() {
    let jobId = this.props.modalCard.mobileJob.jobId
    addRatingToAcceptJobWithoutCode(jobId, this.state.rating, this.state.ratingComment, this.props.instructions).then((response) => {
      if (response !== 'error') {
        this.props.openNotificationModal('accept-rate-modal', "Approved Task!", "Your task has been approved and rated. Thank you!")
        this.props.hide()
      } 
      else {
        this.props.openNotificationModal('accept-rate-modal', "Processing Error", "There was an error processing your rating.")
        this.props.hide()
        }
    })
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({[name]: value})

  },
  starClick: function(numOfStars) {
    let starRoot = '/common/latest/images/consumer/rating-stars/'
    let grayStar = starRoot + '0-gray-star.png'
    let orangeStar = starRoot + '1-orange-star.png'
    let lighterOrangeStar = starRoot + '2-lighterorange-star.png'
    let yellowStar = starRoot + '3-yellow-star.png'
    let lightGreenStar = starRoot + '4-lightgreen-star.png'
    let greenStar = starRoot + '5-green-star.png'

    switch(numOfStars) {
        case 1:
            this.setState({star1: orangeStar, star2: grayStar, star3: grayStar, star4: grayStar, star5: grayStar, rating: 1})
        break
        case 2:
            this.setState({star1: lighterOrangeStar, star2: lighterOrangeStar, star3: grayStar, star4: grayStar, star5: grayStar, rating: 2})
        break
        case 3:
            this.setState({star1: yellowStar, star2: yellowStar, star3: yellowStar, star4: grayStar, star5: grayStar, rating: 3})
        break
        case 4:
            this.setState({star1: lightGreenStar, star2: lightGreenStar, star3: lightGreenStar, star4: lightGreenStar, star5: grayStar, rating: 4})
        break
        case 5:
            this.setState({star1: greenStar, star2: greenStar, star3: greenStar, star4: greenStar, star5: greenStar, rating: 5})
        break
        default:
        break
    }
  },
  render: function () {
    let mediaRoot = '/common/latest/images/consumer/status-icons'
    let checkmark = mediaRoot + '/FINISHED-flat.png'
    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upgrade-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
            <div className='text-center pull-down-xs-3'>
                  <img src={checkmark} style={{height:'40px', width: '50px'}} alt=''></img>
            </div>
            <h2 className='text-center'>Thank you!</h2>
            <p className='text-center baseline-color'><b>Payment has been sent to your contractor</b></p>
            <div className='row text-center' style={{width:'90%', margin:'auto'}}>
                <p className='pull-down-xs-2'>Please provide feedback and rating for the work performed (optional)</p>
                {/*The stars will go here*/}
                <img src={this.state.star1} style={{paddingRight: '10px'}} onClick={() => this.starClick(1)} alt=''></img>
                <img src={this.state.star2} style={{paddingRight: '10px'}} onClick={() => this.starClick(2)} alt=''></img>
                <img src={this.state.star3} style={{paddingRight: '10px'}} onClick={() => this.starClick(3)} alt=''></img>
                <img src={this.state.star4} style={{paddingRight: '10px'}} onClick={() => this.starClick(4)} alt=''></img>
                <img src={this.state.star5} style={{paddingRight: '10px'}} onClick={() => this.starClick(5)} alt=''></img>
              </div>
              <div className='row text-center' style={{width:'90%', margin:'auto'}}>
                  <p className='pull-down-xs-4'>Optional rating comment (these comments are public)</p>
              </div>
              <div className='row' style={{width:'90%', margin:'auto'}}>
                <FormGroup className='center-block pull-down-xs-1' style={{width:'85%'}}>
                    <FormControl className='faq-text' componentClass='textarea' name='ratingComment' id='ratingComment' value={this.state.ratingComment} onChange={this.handleInputChange} style={{height: 111, paddingTop: 20}}/>
                </FormGroup>
              </div>
            <div className='text-center pull-down-xs-3' style={{marginBottom: 30}}>
            <button className='btn btn-success' onClick={this.sendUpdateToServer}>Submit</button>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/accept-task-modal.jsx